import React, { useEffect, useState } from 'react';
import Layout from '../../common/Layout';
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetDataWithToken,
  PostDataWithToken
} from '../../constants/ApiHelper';
import ReactPaginate from 'react-paginate';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';

const MapOccupation = () => {
  const mmvData = useSelector(
    (state) => state?.root?.mmvData
  );

  const dispatch = useDispatch();

  // =========================================================
  // STATES
  // =========================================================

  const [insurer, setInsurer] = useState('');
  const [insurerData, setInsurerData] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [currentItemsData, setCurrentItemsData] =
    useState(false);

  const [insurerRtoData, setInsurerRtoData] =
    useState([]);

  const [partnerRtoData, setPartnerRtoData] =
    useState([]);

  const [selectedValue, setSelectedValue] =
    useState({});

  const [variantIdInput, setVariantIdInput] =
    useState('');

  const [page, setPage] = useState(1);

  const [itemsPerPage, setItemsPerPage] =
    useState(10);

  const [pagination, setPagination] =
    useState({
      totalRecords: 0,
      currentPage: 1,
      totalPages: 0,
      limit: 10
    });

  // =========================================================
  // GET INSURERS
  // =========================================================

  const handleSelectProduct = async () => {
    try {
      setLoading(true);

      const data = new URLSearchParams({
        isMmvPanel: true
      }).toString();

      const res = await GetDataWithToken(
        `/insurers/getAllInsurer?${data}`
      );

      if (res?.success) {
        setInsurerData(res?.data || []);
      } else {
        setInsurerData([]);
        console.log(
          'Insurer Data Error:',
          res?.message
        );
      }
    } catch (error) {
      console.error(
        'Insurer API Error:',
        error
      );

      setInsurerData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSelectProduct();
  }, []);

  // =========================================================
  // SELECT INSURER
  // =========================================================

  const handleSelectInsurer = (
    val,
    insurerList
  ) => {
    setInsurer(val);

    // Reset previous data
    setCurrentItemsData(false);
    setPartnerRtoData([]);
    setInsurerRtoData([]);
    setSelectedValue({});

    // Reset pagination/search
    setPage(1);
    setVariantIdInput('');

    dispatchMmvData(
      'insurerId',
      val
    );

    dispatchMmvData(
      'insurerRtoId',
      ''
    );

    const selectedInsurer =
      insurerList.find(
        (x) =>
          x.insurerId ===
          parseInt(val)
      );

    const insurerName =
      selectedInsurer
        ? selectedInsurer.insurerName
        : '';

    const mappingName =
      selectedInsurer
        ? selectedInsurer.mappingName
        : '';

    dispatchMmvData(
      'insurerName',
      insurerName
    );

    dispatchMmvData(
      'mappingName',
      mappingName
    );
  };

  // =========================================================
  // VALIDATE
  // =========================================================

  const validateForm = () => {
    const newErrors = {};

    if (!insurer) {
      newErrors.insurer =
        'Please select an insurer.';
    }

    setErrors(newErrors);

    return (
      Object.keys(newErrors).length === 0
    );
  };

  // =========================================================
  // GET INSURER OCCUPATION
  // =========================================================

  const getInsurerRto = async () => {
    if (!mmvData?.insurerId) {
      return;
    }

    try {
      const insurerObj = {
        insurerId:
          mmvData?.insurerId || ''
      };

      const res =
        await PostDataWithToken(
          '/occupation/getInOccupationInsurerData',
          insurerObj
        );

      if (res?.status) {
        const data =
          res?.data || [];
          console.log("data",data);
          

    
        


        const arr =
          data.map(
            (item) => ({
              label:
                item?.occupation,
              value:
                item?.id
            })
          );
console.log("arrrrrrrrrrr----",arr);

        setInsurerRtoData(arr);
      } else {
        setInsurerRtoData([]);
      }
    } catch (error) {
      console.error(
        'Insurer Occupation API Error:',
        error
      );

      setInsurerRtoData([]);
    }
  };

  // =========================================================
  // GET PARTNER OCCUPATION
  // =========================================================

  const getPartnerRto = async (
    searchValue = variantIdInput
  ) => {
    if (!mmvData?.insurerId) {
      return;
    }

    setLoading(true);

    const search =
      searchValue?.trim() || '';

    const partnerObj = {
      insurerId:
        mmvData?.insurerId || '',

      search: search,

      currentPage: page,

      limit: itemsPerPage
    };

    try {
      console.log(
        'Occupation Search API Payload:',
        partnerObj
      );

      const res =
        await PostDataWithToken(
          'occupation/get-occupation-insurer',
          partnerObj
        );

      // =====================================================
      // ONLY ACTIVE DATA
      // =====================================================

      const activeData =
        (res?.data || []).filter(
          (item) =>
            item?.isActive === true
        );

      setPartnerRtoData(
        activeData
      );

      setPagination(
        res?.pagination || {
          totalRecords: 0,
          currentPage: page,
          totalPages: 0,
          limit: itemsPerPage
        }
      );
    } catch (error) {
      console.error(
        'Occupation API Error:',
        error
      );

      setPartnerRtoData([]);

      setPagination({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: itemsPerPage
      });
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // SUBMIT
  // =========================================================

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setCurrentItemsData(true);

    // Reset search/page
    setVariantIdInput('');
    setPage(1);

    // Load both APIs
    await Promise.all([
      getInsurerRto(),
      getPartnerRto('')
    ]);
  };

  // =========================================================
  // SEARCH CHANGE
  // =========================================================

  const handleVariantIdChange = (e) => {
    const value =
      e.target.value;

    setVariantIdInput(value);
    setPage(1);
  };

  useEffect(() => {
    if (!currentItemsData) {
      return;
    }

    const search =
      variantIdInput.trim();

    if (
      search.length > 0 &&
      search.length < 3
    ) {
      return;
    }

    getPartnerRto(search);

  }, [
    variantIdInput,
    page,
    itemsPerPage
  ]);

  const handleSelectInsurerRtoId = (
    selectedOption,
    itemId
  ) => {
    dispatchMmvData(
      'insurerRtoId',
      selectedOption?.value || ''
    );

    setSelectedValue(
      (prevSelected) => ({
        ...prevSelected,
        [itemId]:
          selectedOption
      })
    );
  };

  // =========================================================
  // MAP
  // =========================================================

  const handleMapping = (
    item,
    matchingRto
  ) => {
    if (
      !mmvData?.insurerId
    ) {
      toast.error(
        'Please select insurer'
      );
      return;
    }

    if (!matchingRto?.value) {
      toast.error(
        'Please select occupation'
      );
      return;
    }

    setLoading(true);

    const mapObj = {
      insOccupationId:
        matchingRto?.value,

      insurerId:
        mmvData?.insurerId,

      occupationId:
        item,

      action: 'mapped'
    };

    PostDataWithToken(
      'occupation/occupationMapUnmap',
      mapObj
    )
      .then((res) => {
        if (res?.status) {
          toast.success(
            'Occupation Mapped Successfully!!'
          );

          // Refresh current page
          getPartnerRto(
            variantIdInput
          );
        } else {
          toast.error(
            res?.message ||
            'Something went wrong'
          );
        }
      })
      .catch((error) => {
        console.error(
          'Mapping Error:',
          error
        );

        toast.error(
          error?.message ||
          'Mapping failed'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // =========================================================
  // UNMAP
  // =========================================================

  const handleUnMapping = (
    itemId
  ) => {
    if (
      !mmvData?.insurerId
    ) {
      return;
    }

    setLoading(true);

    const mapObj = {
      insOccupationId: '',
      insurerId:
        mmvData?.insurerId,
      occupationId:
        itemId,
      action: 'unmapped'
    };

    PostDataWithToken(
      'occupation/occupationMapUnmap',
      mapObj
    )
      .then((res) => {
        if (res?.status) {
          setSelectedValue(
            (prevSelected) => ({
              ...prevSelected,
              [itemId]: null
            })
          );

          toast.success(
            'Occupation UnMapped Successfully!!'
          );

          // Refresh current page
          getPartnerRto(
            variantIdInput
          );
        } else {
          toast.error(
            res?.message ||
            'Something went wrong'
          );
        }
      })
      .catch((error) => {
        console.error(
          'Unmapping Error:',
          error
        );

        toast.error(
          error?.message ||
          'Unmapping failed'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // =========================================================
  // PAGINATION
  // =========================================================

  const handlePageClick = ({
    selected
  }) => {
    setPage(
      selected + 1
    );
  };

  // =========================================================
  // ITEMS PER PAGE
  // =========================================================

  const handleChangeItemPerPage = (
    e
  ) => {
    const value =
      Number(
        e.target.value
      );

    setItemsPerPage(value);
    setPage(1);
  };

  // =========================================================
  // SEARCH BUTTON
  // =========================================================

  const handleSearch = () => {
    const search =
      variantIdInput.trim();

    if (
      search.length > 0 &&
      search.length < 3
    ) {
      toast.warning(
        'Please enter at least 3 characters to search.'
      );

      return;
    }

    setPage(1);

    getPartnerRto(
      search
    );
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <Layout>

      <div className="container-fluid py-4 dash_main">

        {/* =====================================================
            FILTER CARD
        ===================================================== */}

        <div className="row">

          <div className="card mb-4">

            <div className="card-body pt-0 pb-2">

              <div className="row mt-2">

                {/* INSURER */}

                <div className="col-xl-3 col-lg-3 col-md-6 col-12">

                  <label>
                    Insurer
                  </label>

                  <div className="mb-3">

                    <select
                      className="form-control"
                      onChange={(e) =>
                        handleSelectInsurer(
                          e.target.value,
                          insurerData
                        )
                      }
                      value={insurer}
                      disabled={loading}
                    >

                      <option value="">
                        Select Insurance
                      </option>

                      {insurerData?.map(
                        (
                          item,
                          index
                        ) => (
                          <option
                            key={
                              index
                            }
                            value={
                              item?.insurerId
                            }
                          >
                            {
                              item?.mappingName
                            }
                          </option>
                        )
                      )}

                    </select>

                    {errors.insurer && (
                      <div className="text-danger">
                        {
                          errors.insurer
                        }
                      </div>
                    )}

                  </div>

                </div>

                {/* SUBMIT */}

                <div className="col-xl-3 col-lg-3 col-md-6 col-12">

                  <label>
                    &nbsp;
                  </label>

                  <div className="mb-3 d-flex justify-content-end gap-3">

                    <button
                      type="button"
                      className="btn btn-sec"
                      onClick={
                        handleSubmit
                      }
                      disabled={
                        loading ||
                        !insurer
                      }
                    >
                      {loading
                        ? 'Loading...'
                        : 'Submit'}
                    </button>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

        {/* =====================================================
            DATA
        ===================================================== */}

        {currentItemsData && (

          <>

            {loading ? (

              <div className="loading">

                <div className="spinner"></div>

                <p>
                  Loading...
                </p>

              </div>

            ) : (

              <div className="col-12">

                <div className="card mb-4">
                  <div className="card-body pt-3 pb-2">

                    <div className="row">

                      <div className="col-xl-5 col-lg-6 col-md-8 col-12">

                        <label>
                          Search Occupation
                        </label>

                        <div className="d-flex gap-2">

                          <input
                            type="search"
                            placeholder="Search Occupation"
                            className="form-control"
                            value={
                              variantIdInput
                            }
                            onChange={
                              handleVariantIdChange
                            }
                          />

                          <button
                            type="button"
                            className="btn btn-sec"
                            onClick={
                              handleSearch
                            }
                            disabled={
                              loading ||
                              (
                                variantIdInput.trim()
                                  .length > 0 &&
                                variantIdInput.trim()
                                  .length < 3
                              )
                            }
                          >
                            Search
                          </button>

                        </div>

                        {variantIdInput.trim()
                          .length > 0 &&
                          variantIdInput.trim()
                            .length < 3 && (
                            <small className="text-danger">
                              Please enter at least 3 characters.
                            </small>
                          )}

                      </div>

                    </div>

                  </div>

                  {/* =================================================
                      TABLE
                  ================================================= */}

                  <div className="card-body pt-0 pb-2">

                    <div className="table-responsive p-0">

                      <table className="table align-items-center mb-0">

                        <thead>

                          <tr>

                            <th className="text-uppercase text-xxs font-weight-bolder text-dark">
                              Product Occupation
                            </th>

                            <th className="text-uppercase text-xxs font-weight-bolder text-dark">
                              Insurer Occupation
                            </th>

                            <th
                              className="text-uppercase text-xxs font-weight-bolder fs-4"
                              style={{
                                color: '#000'
                              }}
                            >
                              Action
                            </th>

                          </tr>

                        </thead>

                        <tbody>

                          {partnerRtoData?.length >
                            0 ? (

                            partnerRtoData.map(
                              (
                                item,
                                index
                              ) => {

                                // Safety check:
                                // inactive data will never render
                                if (
                                  item?.isActive !==
                                  true
                                ) {
                                  return null;
                                }

                                const insurerRtoId =
                                  item?.[
                                  mmvData?.mappingName
                                  ];

                                const matchingRto =
                                  insurerRtoData.find(
                                    (
                                      data
                                    ) =>
                                      data.value ===
                                      insurerRtoId
                                  );

                                const selectedOccupation =
                                  Object.prototype.hasOwnProperty.call(
                                    selectedValue,
                                    item.id
                                  )
                                    ? selectedValue[
                                    item.id
                                    ]
                                    : matchingRto ||
                                    null;

                                return (

                                  <tr
                                    key={
                                      item?.id ||
                                      index
                                    }
                                  >

                                    {/* PRODUCT OCCUPATION */}

                                    <td className="select_partner">

                                      {
                                        item?.occupation
                                      }

                                    </td>

                                    {/* INSURER OCCUPATION */}

                                    <td
                                      style={{
                                        width:
                                          '45%'
                                      }}
                                    >

                                      <div className="mmv_select">

                                        <ReactSelect
                                          options={
                                            insurerRtoData
                                          }
                                          name="occupation"
                                          value={
                                            selectedOccupation
                                          }
                                          placeholder="Select Occupation"
                                          onChange={(
                                            selectedOption
                                          ) =>
                                            handleSelectInsurerRtoId(
                                              selectedOption,
                                              item.id
                                            )
                                          }
                                          className="select_ins"
                                          menuPortalTarget={
                                            document.body
                                          }
                                          styles={{
                                            menuPortal:
                                              (
                                                base
                                              ) => ({
                                                ...base,
                                                zIndex: 9999
                                              })
                                          }}
                                        />

                                      </div>

                                    </td>

                                    {/* ACTION */}

                                    <td>

                                      <div className="d-flex gap-2">

                                        <button
                                          type="button"
                                          className="btn btn-sec"
                                          onClick={() =>
                                            handleMapping(
                                              item?.id,
                                              selectedOccupation
                                            )
                                          }
                                          disabled={
                                            !selectedOccupation ||
                                            loading
                                          }
                                        >
                                          Map
                                        </button>

                                        <button
                                          type="button"
                                          className="btn suc-btn"
                                          onClick={() =>
                                            handleUnMapping(
                                              item?.id
                                            )
                                          }
                                          disabled={
                                            loading
                                          }
                                        >
                                          Unmap
                                        </button>

                                      </div>

                                    </td>

                                  </tr>

                                );
                              }
                            )

                          ) : (

                            <tr>

                              <td
                                colSpan="3"
                                className="text-center py-4"
                              >
                                No Record Found
                              </td>

                            </tr>

                          )}

                        </tbody>

                      </table>

                    </div>

                  </div>

                </div>

                {/* =================================================
                    PAGINATION
                ================================================= */}

                <div className="card mb-4 p-3">

                  <div className="d-flex align-items-center justify-content-between flex-wrap">

                    <div>

                      <p className="mb-0">

                        Showing{' '}

                        {pagination?.totalRecords
                          ? (
                            (
                              page -
                              1
                            ) *
                            itemsPerPage
                          ) + 1
                          : 0}

                        {' - '}

                        {Math.min(
                          page *
                          itemsPerPage,
                          pagination?.totalRecords ||
                          0
                        )}

                        {' of '}

                        {
                          pagination?.totalRecords ||
                          0
                        }

                      </p>

                    </div>

                    <div className="main-page-item">

                      <div className="show-page">

                        <select
                          className="form-control"
                          value={
                            itemsPerPage
                          }
                          onChange={
                            handleChangeItemPerPage
                          }
                        >

                          <option value={10}>
                            10
                          </option>

                          <option value={20}>
                            20
                          </option>

                          <option value={30}>
                            30
                          </option>

                          <option value={50}>
                            50
                          </option>

                          <option value={100}>
                            100
                          </option>

                        </select>

                      </div>

                      <div>

                        <ReactPaginate
                          breakLabel="..."
                          previousLabel="<"
                          nextLabel=">"
                          onPageChange={
                            handlePageClick
                          }
                          pageCount={
                            pagination?.totalPages ||
                            0
                          }
                          forcePage={
                            page - 1
                          }
                          pageRangeDisplayed={
                            5
                          }
                          marginPagesDisplayed={
                            2
                          }
                          renderOnZeroPageCount={
                            null
                          }
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                        />

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            )}

          </>

        )}

      </div>

    </Layout>
  );
};

export default MapOccupation;